import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { MappedChannelForAccommodation } from '../../types/reserveMonitoringList'
import MonitoringReserveTableRow from './MonitoringReserveTableRow'
import useStyles from './styles/MonitoringReserveTableDynamicContent.styles'

type MonitoringReserveTableDynamicContentProps = {
  uniqueChannelNames: string[]
  mappedChannelsForAccommodation: MappedChannelForAccommodation[]
  AccommodationIds: string[]
}

export default function MonitoringReserveTableDynamicContent({
  uniqueChannelNames,
  mappedChannelsForAccommodation,
  AccommodationIds
}: MonitoringReserveTableDynamicContentProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {uniqueChannelNames.map((channelName) => (
          <div className={classes.singleHeader}>
            <Typography className={classes.channelName}>
              {channelName}
            </Typography>
            <div className={classes.subTitles}>
              <Typography className={classes.connect}>
                {getTranslate('Connect')}
              </Typography>
              <div className={classes.connect}>{'30'}</div>
              <div className={classes.connect}>{'90'}</div>
            </div>
          </div>
        ))}
      </div>
      <div className={classes.rows}>
        {mappedChannelsForAccommodation
          .filter((ele) => AccommodationIds.includes(ele.accommodationId))
          .map((item, index) => (
            <MonitoringReserveTableRow
              data={item}
              mappedChannelsForAccommodationIndex={index}
            />
          ))}
      </div>
    </div>
  )
}
